// ELMO IDS
import {
  CREATE_PROFILE_PRODUCTION_EXPERIMENT_ID,
  CREATE_PROFILE_PRODUCTION_TREATMENT_ID,
  MODULAR_PROFILE_PRODUCTION_EXPERIMENT_ID,
  MODULAR_PROFILE_PRODUCTION_TREATMENT_ID,
} from './elmo'

// MODULAR PROFILE
export const commonModularProfileFptiProperties = {
  experimentId: MODULAR_PROFILE_PRODUCTION_EXPERIMENT_ID,
  treatmentId: MODULAR_PROFILE_PRODUCTION_TREATMENT_ID,
}

// CREATE PROFILE
export const commonCreateProfileFptiProperties = {
  pageGroup: 'create_business_profile',
  experimentId: CREATE_PROFILE_PRODUCTION_EXPERIMENT_ID,
  treatmentId: CREATE_PROFILE_PRODUCTION_TREATMENT_ID,
}
